// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_bs-0";
export var orangeButton = "_bs-1";